import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useParams } from 'react-router';

import { type UserType, useUserById } from '@/api/user';
import UserDetailContent from '@/app/users/[user]/UserDetailContent';
import Error404 from '@/components/errors/Error404';
import { PageSpinner } from '@/components/loaders';
import { Page } from '@/components/page';
import { InstanceNavigate } from '@/components/routing';
import SolAPIError from '@/error/SolAPIError';
import { useMe } from '@/providers/User';
import { ROUTES } from '@/router';

const UserDetail = () => {
  const loggedInUser = useMe();
  const { user: userId } = useParams();
  const { user, isLoading, error, mutate } = useUserById(userId);

  const handleSubmitSuccess = (newUser: UserType) => {
    mutate({
      users: {
        getById: newUser,
      },
    });
  };

  if (userId === loggedInUser?.id) {
    return <InstanceNavigate to={ROUTES.profile.path} replace />;
  }

  return (
    <Page title={t`Settings`} pageName={user?.name} exampleAIQuestions={[]}>
      {isLoading && <PageSpinner />}
      {error instanceof SolAPIError && error.is404() ? (
        <Error404 title={<Trans>The user you're looking for does not exist</Trans>} />
      ) : (
        user && <UserDetailContent user={user} onSubmitSuccess={handleSubmitSuccess} />
      )}
    </Page>
  );
};

export default UserDetail;
